<template>
  <div>
    <div class="mesCon" v-show="isChartShow">
      <i slot="blockTit" class="blockTit" @click="jumpLink(type)">收起<i class="el-icon-caret-top"></i></i>
      <div slot="blockCon" class="blockCon">
        <div class="topFilter">
          <div style="display:inline-block">
            <serviceList
              :type='type'
              :selectChannels='selectChannels'
              :chartParam="chartParam"
              @choose-channel='getChooseChannel'
              @choose-name='getName'
            >
            </serviceList>
          </div>
        </div>
        <!-- 展示折线图 -->
        <OrgLineCharts
          :dateData="dateData"
          :leftSeriesData="leftSeriesData"
          :rightSeriesData="rightSeriesData"
          :legendData="legendData"
          :key="type"
          :pageType="type"
        />
      </div>
    </div>
    <div class="mesCon" v-show="!isChartShow">
      <i slot="blockTit" class="blockTit" @click="jumpLink(type)">展开<i class="el-icon-caret-bottom"></i></i>
    </div>
  </div>
</template>

<script>
/**
 * @param type：类型(pubMessage:公众号消息，shotMessage：短信消息，pubMessage：公众号模版消息， customMessage： 公众号客服消息)
 * @param get-message-data：数据变化的回调函数
 * @param editQuery： 当前已选择数据
 * @param dateData： 折线图数据
 * @param seriesData： 折线图标题数据
 * 调用示例: <mesCon type='xx' slot="blockCon" @get-message-data='xx' :editQuery='xx' :dateData="xx" :seriesData="xx"></mesCon>
 */
import OrgLineCharts from '@/components/OrgLineCharts/OrgLineCharts'
import serviceList from '@/components/common/serviceList'

export default {
  name: 'mesCon',
  props: {
    tit_txt: String,
    dateData: Array,
    leftSeriesData: Array,
    rightSeriesData: Array,
    selectChannels: Array,
    type: String,
    isChartShow: Boolean,
    legendDataArr: Array,
    chartParam: Object
  },
  data() {
    return {
      selectTimeArr: [
        {
          key: 'lastMonth',
          name: '上月'
        },
        {
          key: 'currentMonth',
          name: '本月'
        },
        {
          key: 'customTime',
          name: '自定义'
        }
      ],
      selectItem: '本月',
      chooseTime: '',
      chooseObj: {},
      chooseCountry: null,
      showPicker: false,
      pickerValue: '',
      pickerOptions: {
        disabledDate(time) {
          // 限制选择当天之前的日期
          return time.getTime() > Date.now();
        }
      },
      legendData: this.type === 'timeOrgTerm' ? this.legendDataArr : ['公益课账号领取人数', '公益课首课完课人数']
    }
  },
  components: {
    OrgLineCharts,
    serviceList
  },
  methods: {
    jumpLink() {
      this.$emit('showLineChart', 'cixinbb')
    },
    getChooseChannel(obj) {
      this.$emit('get-message-data', obj)
    },
    getName(arr) {
      this.legendData = arr
    }
  },
  watch: {
    legendDataArr: {
      handler(newVal) {
        if (newVal && this.type === 'timeOrgTerm') {
          this.legendData = newVal
        }
      }
    },
    deep: true
  }
};
</script>

<style lang="less" scoped>
.mesCon{
  padding: 10px 0px;
  .blockTit{
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    color: #FE9400;
  }
  .blockTit:hover{
    text-decoration: underline;
  }
  .blockCon{
    .topFilter{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
